import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faDiscord,
  faInstagram,
  faLinkedin,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';
import '../home/Home.css';

class Footer extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="container-fluid footer-div">
        <div className="container footer-div">
          <div className="row">
            <div className="col-sm-3">
              <a href="/">
                <img className="hype-pilot-logo" src="/images/hpinc.png" />
              </a>
              <div class="contact-info">
                <div>team@hypepilot.com</div>
                <div>+1 512 317 9200</div>
                <div>600 Congress, Austin, Texas 78701</div>
              </div>
            </div>
            <div className="col-sm-3">
              <ul className="footer-column">
                <li className="footer-column-first-child">Features</li>
                <li className="social-link sliding-middle-out-small">
                  <a href="#brands-section">Brand</a>
                </li>
                <li className="social-link sliding-middle-out-small">
                  <a href="#influencers-section">Influencer</a>
                </li>
                <li className="social-link sliding-middle-out-small">Help</li>
              </ul>
            </div>

            <div className="col-sm-3">
              <ul className="footer-column">
                <li className="footer-column-first-child">Resources</li>
                <li className="social-link sliding-middle-out-small">
                  <NavLink
                    className="social-link sliding-middle-out-small"
                    to="/terms-of-service"
                  >
                    Terms of Use
                  </NavLink>
                </li>
                <li className="social-link sliding-middle-out-small">
                  <NavLink
                    className="social-link sliding-middle-out-small"
                    to="/privacy-policy"
                  >
                    Privacy Policy
                  </NavLink>
                </li>
                <li className="social-link sliding-middle-out-small">
                  <a
                    href="https://hypepilot.zendesk.com/hc/en-us"
                    target="_blank"
                    className="social-link sliding-middle-out-small"
                  >
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-sm-3">
              <ul className="footer-column">
                <li className="footer-column-first-child">Company</li>
                <li className="social-link">
                  <a
                    target="_blank"
                    className="social-link sliding-middle-out-small"
                    href="https://angel.co/hypepilot/jobs"
                  >
                    Careers
                  </a>
                </li>
                <a href="https://medium.com/hypepilot" target="_blank">
                  <li className="social-link sliding-middle-out-small">Blog</li>
                </a>
              </ul>
            </div>
          </div>
          <div className="social-links">
            <div className="social-links-table">
              <div className="social-links-table-row">
                <a href="https://www.facebook.com/hypepilot/" target="_blank">
                  <FontAwesomeIcon
                    className="social-link-icon"
                    icon={faFacebook}
                  />
                </a>
                <a href="https://discord.gg/KjBGXhX">
                  <FontAwesomeIcon
                    className="social-link-icon"
                    icon={faDiscord}
                  />
                </a>
                <a
                  href="https://www.instagram.com/hypepilot.hq"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    className="social-link-icon"
                    icon={faInstagram}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/hypepilot/about/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    className="social-link-icon"
                    icon={faLinkedin}
                  />
                </a>
                <a href="https://twitter.com/HypepilotHQ" target="_blank">
                  <FontAwesomeIcon
                    className="social-link-icon"
                    icon={faTwitter}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js